/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(regeneratorRuntime) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var defineProperty = Object.defineProperty || function (obj, key, desc) {
    obj[key] = desc.value;
  };
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) });

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: true });
  defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: true });
  GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction ||
    // For the native GeneratorFunction constructor, the best we can
    // do is to check its .name property.
    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };

  exports.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function (arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function (unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function (error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
      // If enqueue has been called before, then we want to wait until
      // all previous Promises have been resolved before calling invoke,
      // so that results are always delivered in the correct order. If
      // enqueue has not been called before, then it is important to
      // call invoke immediately, without waiting on a callback to fire,
      // so that the async generator function has the opportunity to do
      // any necessary setup in a predictable way. This predictability
      // is why the Promise constructor synchronously invokes its
      // executor callback, and why async functions synchronously
      // execute code before the first await. Since we implement simple
      // async functions in terms of async generators, it is especially
      // important to get this right, even though it requires care.
      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
      // Avoid propagating failures to Promises returned by later
      // invocations of the iterator.
      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    defineProperty(this, "_invoke", { value: enqueue });
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);

    return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
    : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method;
    var method = delegate.iterator[methodName];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method, or a missing .next mehtod, always terminate the
      // yield* loop.
      context.delegate = null;

      // Note: ["return"] must be used for ES3 parsing compatibility.
      if (methodName === "throw" && delegate.iterator["return"]) {
        // If the delegate iterator has a return method, give it a
        // chance to clean up.
        context.method = "return";
        context.arg = undefined;
        maybeInvokeDelegate(delegate, context);

        if (context.method === "throw") {
          // If maybeInvokeDelegate(context) changed context.method from
          // "return" to "throw", let that override the TypeError below.
          return ContinueSentinel;
        }
      }
      if (methodName !== "return") {
        context.method = "throw";
        context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (!info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }
    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function () {
    return this;
  });

  define(Gp, "toString", function () {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function (val) {
    var object = Object(val);
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function reset(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function stop() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function dispatchException(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function complete(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;
})(
// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
 true ? module.exports : {});

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(5);

__webpack_require__(4);

__webpack_require__(7);

__webpack_require__(6);

__webpack_require__(3);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function showVideo(value) {
  jQuery(document).ajaxComplete(function () {
    jQuery('.view-id-spritzer_gallery .view-filters .radio .js-form-item-field-tags-target-id').each(function () {
      jQuery(this).find('label').css("background-color", "#e2aaa4");
    });

    if (value === "1") {
      jQuery(".paragraph--type--spritzer-videos-reference .field--name-field-spritzer-videos-referencin .field__items .field__item .spritzer-gallery-video").hide();
      jQuery(".paragraph--type--spritzer-videos-reference .field--name-field-spritzer-videos-referencin .field__items .field__item:nth-child(1) .spritzer-gallery-video").show();
      jQuery('.view-id-spritzer_gallery .view-filters .radio .js-form-item-field-tags-target-id:nth-child(2) label').css("background-color", "#cb4552");
    } else if (value === "2") {
      jQuery(".paragraph--type--spritzer-videos-reference .field--name-field-spritzer-videos-referencin .field__items .field__item .spritzer-gallery-video").hide();
      jQuery(".paragraph--type--spritzer-videos-reference .field--name-field-spritzer-videos-referencin .field__items .field__item:nth-child(2) .spritzer-gallery-video").show();
      jQuery('.view-id-spritzer_gallery .view-filters .radio .js-form-item-field-tags-target-id:nth-child(3) label').css("background-color", "#cb4552");
    } else if (value === "3") {
      jQuery(".paragraph--type--spritzer-videos-reference .field--name-field-spritzer-videos-referencin .field__items .field__item .spritzer-gallery-video").hide();
      jQuery(".paragraph--type--spritzer-videos-reference .field--name-field-spritzer-videos-referencin .field__items .field__item:nth-child(3) .spritzer-gallery-video").show();
      jQuery('.view-id-spritzer_gallery .view-filters .radio.js-form-item-field-tags-target-id:nth-child(4) label').css("background-color", "#cb4552");
    }
  });
}

jQuery(document).ajaxComplete(function () {
  jQuery('.js-form-item-field-tags-target-id').click(function () {
    showVideo(jQuery(this).find('input').attr("value"));
  });

  jQuery('.gallery-images .js-form-item-field-tags-target-id .form-select').on('change', function () {
    switchVideo(jQuery(this).find(":selected").attr("value"));
  });
});
jQuery('.spritzer-gallery-video .play-button').on('click', function (e) {
  // Remove autoplay=1 from all iframes
  jQuery('.spritzer-gallery-video').find('iframe').each(function () {
    var src = jQuery(this).attr('src');
    if (src) {
      // Remove autoplay=1 from the src if it exists
      var newSrc = src.replaceAll(/&autoplay=1/g, "");
      // Remove trailing '?' or '&' if present after autoplay=1 removal
      newSrc = newSrc.replace(/[?&]$/, '');
      jQuery(this).attr('src', newSrc);
    }
  });

  // Hide the play button and show the selected iframe
  jQuery(this).parent().hide();
  jQuery(this).parent().parent().find('iframe').show();
  jQuery(this).parent().parent().find('iframe')[0].src += "&autoplay=1";
});
//spritzer gallery page
var btn = jQuery('#button');
jQuery(window).scroll(function () {
  if (jQuery(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function (e) {
  e.preventDefault();
  jQuery('html, body').animate({ scrollTop: 0 }, '300');
});

jQuery(document).ready(function () {
  jQuery('.gallery-tiles').hide();
});

jQuery('.field--name-field-toggle-carousel img').click(function () {
  jQuery('.gallery-scroll').show();
  jQuery('.gallery-tiles').hide();
});

jQuery('.field--name-field-toggle-grid img').click(function () {
  jQuery('.gallery-tiles').show();
  jQuery('.gallery-scroll').hide();
});

jQuery(function () {
  jQuery('.toggle-group .field--type-image img').on('click', function () {
    jQuery('.toggle-group .field--type-image img').removeClass('active-switch');
    jQuery(this).toggleClass("active-switch");
  });
});

function switchVideo(value) {
  jQuery('.gallery-images .js-form-item-field-tags-target-id .form-select').each(function () {
    if (value === "1") {
      jQuery(".paragraph--type--spritzer-videos-reference .field--name-field-spritzer-videos-referencin .field__items .field__item .spritzer-gallery-video").hide();
      jQuery(".paragraph--type--spritzer-videos-reference .field--name-field-spritzer-videos-referencin .field__items .field__item:nth-child(1) .spritzer-gallery-video").show();
    } else if (value === "2") {
      jQuery(".paragraph--type--spritzer-videos-reference .field--name-field-spritzer-videos-referencin .field__items .field__item .spritzer-gallery-video").hide();
      jQuery(".paragraph--type--spritzer-videos-reference .field--name-field-spritzer-videos-referencin .field__items .field__item:nth-child(2) .spritzer-gallery-video").show();
    } else if (value === "3") {
      jQuery(".paragraph--type--spritzer-videos-reference .field--name-field-spritzer-videos-referencin .field__items .field__item .spritzer-gallery-video").hide();
      jQuery(".paragraph--type--spritzer-videos-reference .field--name-field-spritzer-videos-referencin .field__items .field__item:nth-child(3) .spritzer-gallery-video").show();
    }
  });
}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(regeneratorRuntime) {

var _this2 = this;

var playCards = document.querySelector('.play-cards');

document.addEventListener('DOMContentLoaded', function () {

  if (playCards) {

    var iteraItems = function iteraItems() {

      var playCardsContent = playCards.querySelectorAll('.play-cards--content .play-cards--item');

      playCardsContent.forEach(function (cardItem) {

        cardItem.addEventListener('click', function (e) {

          playCardsContent.forEach(function (otherCard) {
            var gift = otherCard.querySelector('.play-cards--gift');
            otherCard.classList.remove('active');
            otherCard.classList.add('disable');
            gift.classList.remove('card--hidden');
          });

          cardItem.classList.add('active');
          cardItem.classList.remove('disable');

          if (e.target.classList.contains('active')) {

            var query = function query() {
              var cardsContainer;
              return regeneratorRuntime.async(function query$(context$5$0) {
                var _this = this;

                while (1) switch (context$5$0.prev = context$5$0.next) {
                  case 0:
                    context$5$0.prev = 0;
                    context$5$0.next = 3;
                    return regeneratorRuntime.awrap((function callee$5$0() {
                      var urlQuery, reqQuery, resQuery, pathOrigin, cardsContainer;
                      return regeneratorRuntime.async(function callee$5$0$(context$6$0) {
                        while (1) switch (context$6$0.prev = context$6$0.next) {
                          case 0:
                            urlQuery = '/prize/win';
                            context$6$0.next = 3;
                            return regeneratorRuntime.awrap(fetch(urlQuery));

                          case 3:
                            reqQuery = context$6$0.sent;
                            context$6$0.next = 6;
                            return regeneratorRuntime.awrap(reqQuery.json());

                          case 6:
                            resQuery = context$6$0.sent;

                            if (reqQuery.status == 200) {
                              (function () {

                                var imgGift = document.querySelector('.play-cards--item.active .play-cards--gift');
                                var titlePlay = document.querySelector('#play-cards__title h1');
                                var cardsContainer = document.querySelector('.play-cards--content');
                                var imgPrize = document.querySelector('.play-cards--img');
                                var btnContinue = document.querySelector('.play-cards--continue');
                                var subTitle = document.querySelector('.play-cards--header__subtitle');

                                if (imgPrize || btnContinue || subTitle) {
                                  imgPrize.remove();
                                  btnContinue.remove();
                                  subTitle.remove();
                                }

                                setTimeout(function () {

                                  if (resQuery.status == 'haveprize' || resQuery.status == 'yesprize') {

                                    var imgWin = document.createElement('img');
                                    imgWin.classList.add('play-cards--img');
                                    imgWin.src = '' + (resQuery.image.uri ? resQuery.image.uri : '');
                                    imgWin.alt = '' + (resQuery.image.alt ? resQuery.image.alt : '');
                                    imgGift.insertAdjacentElement('afterend', imgWin);
                                    imgGift.classList.add('card--hidden');
                                    var spanWinner = document.createElement('span');
                                    spanWinner.classList.add('play-cards--header__subtitle');
                                    spanWinner.innerHTML = resQuery.title ? resQuery.title : '';
                                    titlePlay.insertAdjacentElement('beforebegin', spanWinner);

                                    if (resQuery.status == 'haveprize') {
                                      spanWinner.remove();
                                      titlePlay.innerHTML = resQuery.paragraph ? resQuery.paragraph : '';
                                    }

                                    if (resQuery.status == 'yesprize') {
                                      titlePlay.innerHTML = resQuery.node_title ? resQuery.node_title : '';
                                    }

                                    var btnW = resQuery.text_butom ? resQuery.text_butom : 'CLICK TO CONTINUE';
                                    var urlW = resQuery.url_button ? resQuery.url_button : '/';

                                    cardsContainer.insertAdjacentHTML('beforeend', '<div class="play-cards--continue"><a href="' + urlW + '">' + btnW + '</a></div>');
                                  }

                                  if (resQuery.status == 'tryagain' || resQuery.status == 'noprize') {

                                    var textTry = document.createElement('div');
                                    textTry.classList.add('play-cards--try');
                                    textTry.innerHTML = resQuery.body ? resQuery.body : '<p>Try Again</p>';
                                    imgGift.insertAdjacentElement('afterend', textTry);
                                    imgGift.classList.add('card--hidden');

                                    titlePlay.innerHTML = resQuery.title ? resQuery.title : '';

                                    playCardsContent.forEach(function (cardItemDisale) {

                                      if (cardItemDisale.classList.contains('disable')) {
                                        var referenceImg = cardItemDisale.querySelector('.play-cards--gift');
                                        if (resQuery.other_prize.length > 0) {

                                          var otherImage = document.createElement('img');
                                          otherImage.classList.add('play-cards--imgOther');

                                          var imageRandom = Math.floor(Math.random() * resQuery.other_prize.length);
                                          var urlImageRandom = resQuery.other_prize[imageRandom];

                                          otherImage.src = '' + (urlImageRandom.image.uri ? urlImageRandom.image.uri : '');
                                          referenceImg.insertAdjacentElement('afterend', otherImage);
                                          referenceImg.classList.add('card--hidden');
                                        }
                                      }
                                    });

                                    var btnL = resQuery.text_butom ? resQuery.text_butom : 'VIEW MORE';
                                    var urlL = resQuery.url_button ? resQuery.url_button : '/';

                                    cardsContainer.insertAdjacentHTML('beforeend', '<div class="play-cards--continue"><a href="' + urlL + '">' + btnL + '</a></div>');
                                  }

                                  if (resQuery.status == 'experience') {

                                    if (resQuery.body !== null) {
                                      var textExp = document.createElement('div');
                                      textExp.classList.add('play-cards--experience');
                                      textExp.innerHTML = resQuery.body ? resQuery.body : '';
                                      imgGift.insertAdjacentElement('afterend', textExp);
                                    } else if (resQuery.image.uri !== undefined) {
                                      var imageExp = document.createElement('img');
                                      imageExp.classList.add('play-cards--imgExp');
                                      imageExp.src = '' + resQuery.image.uri;
                                      imgGift.insertAdjacentElement('afterend', imageExp);
                                    }

                                    imgGift.classList.add('card--hidden');

                                    titlePlay.innerHTML = resQuery.node_title ? 'Experience: ' + resQuery.node_title : '';

                                    var spanExp = document.createElement('span');
                                    spanExp.classList.add('play-cards--header__subtitle');
                                    spanExp.innerHTML = resQuery.title ? resQuery.title : '';
                                    titlePlay.insertAdjacentElement('beforebegin', spanExp);

                                    var btnE = resQuery.text_butom ? resQuery.text_butom : 'CLICK TO CONTINUE';
                                    var urlE = resQuery.url_button ? resQuery.url_button : '/';

                                    cardsContainer.insertAdjacentHTML('beforeend', '<div class="play-cards--continue"><a href="' + urlE + '">' + btnE + '</a></div>');
                                  }
                                }, 1600);
                              })();
                            } else if (reqQuery.status == 403) {
                              pathOrigin = window.location.origin;

                              window.location.href = pathOrigin + '/otp/login';
                            } else if (reqQuery.status == 500) {
                              cardsContainer = document.querySelector('.play-cards--content');

                              cardsContainer.insertAdjacentHTML('beforeend', '<div class="play-cards--error"><p>500 INTERNAL SERVER ERROR</p></div>');
                            }

                          case 8:
                          case 'end':
                            return context$6$0.stop();
                        }
                      }, null, _this);
                    })());

                  case 3:
                    context$5$0.next = 9;
                    break;

                  case 5:
                    context$5$0.prev = 5;
                    context$5$0.t0 = context$5$0['catch'](0);
                    cardsContainer = document.querySelector('.play-cards--content');

                    cardsContainer.insertAdjacentHTML('beforeend', '<div class="play-cards--error"><p>YOU ARE TRYING AN INVALID ACTION. CLICK <a href="/otp/login">HERE</a></p></div>');

                  case 9:
                  case 'end':
                    return context$5$0.stop();
                }
              }, null, _this2, [[0, 5]]);
            };

            query();
          }
        });
      });
    };

    iteraItems();
  }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var openToBelong = document.querySelector('body.open-to-belong');

var tag = document.createElement('script');

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

window.onload = function () {

  if (openToBelong) {
    var ytIDD;
    var ytIDM;
    var player;

    (function () {
      var onYouTubeIframeAPIReady = function onYouTubeIframeAPIReady() {
        player = new YT.Player('player', {
          videoId: mediaScreen ? ytIDM : ytIDD,
          playerVars: {
            'autoplay': 1,
            'mute': 1,
            'controls': 0,
            'showinfo': 0,
            'rel': 0
          },
          events: {
            'onReady': onPlayerReady
          }
        });

        function onPlayerReady(event) {
          event.target.playVideo();

          var interval = setInterval(function () {

            var duration = parseInt(player.getDuration()) - 1;
            var current = parseInt(player.getCurrentTime());

            if (current == duration) {
              clearInterval(interval);
              window.location.href = pathOrigin + '/user/register';
            }

            if (current > 0) {
              gifLoadVideo.remove();
            }
          }, 1000);
        }
      };

      ytIDD = document.getElementsByClassName('field--name-field-vid-youtube')[0].outerText;
      ytIDM = document.getElementsByClassName('field--name-field-vid-youtube-mb')[0].outerText;

      var gifLoadVideo = document.getElementById('gif-loader');
      var pathOrigin = window.location.origin;
      var mediaScreen = window.screen.width < 768;

      onYouTubeIframeAPIReady();
    })();
  }
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


jQuery("#webform-submission-otp-login-node-121-add-form #edit-phone-number").keyup(function () {
    var cellphone = jQuery(this).val();
    if (cellphone.charAt(0) === '0') {
        jQuery(this).val('27');
    }
    if (cellphone.charAt(2) === '0') {
        jQuery(this).val('27');
    }
    jQuery(this).val(jQuery(this).val().replace(/\s/g, ''));
});

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var userRegisterForm = document.querySelector('.user-register-form');

if (userRegisterForm) {
  (function () {
    var jsDate = userRegisterForm.querySelector('.js-form-type-date');
    var inputDate = userRegisterForm.querySelector('.js-form-type-date input.form-date');
    var submitButton = userRegisterForm.querySelector('#edit-submit');
    var minAge = 18;

    jQuery(".user-register-form #edit-field-cellphone").keyup(function () {
      var cellphone = jQuery(this).val();
      if (cellphone.charAt(0) === '0') {
        jQuery(this).val('27');
      }
      if (cellphone.charAt(2) === '0') {
        jQuery(this).val('27');
      }
      jQuery(this).val(jQuery(this).val().replace(/\s/g, ''));
    });

    var ageValidation = function ageValidation() {
      var inputValue = inputDate.value;
      var userDate = new Date(inputValue);
      var userYear = userDate.getFullYear();
      var userAge = new Date(Date.now() - userDate.getTime()).getUTCFullYear() - 1970;
      var labelError = userRegisterForm.querySelector('.js-form-type-date label.error');

      if (userAge < minAge) {
        inputDate.parentNode.classList.add('error');
        submitButton.disabled = true;
        if (!labelError) {
          jsDate.insertAdjacentHTML('beforeend', '<label class="error">You must be over 18 to register</label>');
        }
      } else {
        inputDate.parentNode.classList.remove('error');
        if (labelError) {
          labelError.remove();
        }
        submitButton.disabled = false;
      }
      if (userYear.toString().length !== 4) {
        if (labelError) {
          labelError.remove();
        }
      }
    };

    inputDate.addEventListener('input', function () {
      ageValidation();
    });

    var inputName = userRegisterForm.querySelector('.field--name-field-name input.form-control');

    inputName.addEventListener('input', function () {

      var labelErrorN = userRegisterForm.querySelector('.field--name-field-name label.error-character');

      var textName = inputName.value;
      var onlyTextN = textName.replace(/[0-9]/g, '');
      inputName.value = onlyTextN;
      if (textName.length < 3 && textName.length > 0) {
        inputName.classList.add('error');
        if (!labelErrorN) {
          inputName.insertAdjacentHTML('afterend', '<label class="error-character">The Name must have more than 2 characters.</label>');
        }
      } else {
        inputName.classList.remove('error-character');
        if (labelErrorN) {
          labelErrorN.remove();
        }
      }
    });

    var inputSurname = userRegisterForm.querySelector('.field--name-field-surname input.form-control');

    inputSurname.addEventListener('input', function () {

      var labelErrorS = userRegisterForm.querySelector('.field--name-field-surname label.error-character');

      var textSurname = inputSurname.value;
      var onlyTextS = textSurname.replace(/[0-9]/g, '');
      inputSurname.value = onlyTextS;
      if (textSurname.length < 3 && textSurname.length > 0) {
        inputSurname.classList.add('error');
        if (!labelErrorS) {
          inputSurname.insertAdjacentHTML('afterend', '<label class="error-character">The Surname must have more than 2 characters.</label>');
        }
      } else {
        inputSurname.classList.remove('error-character');
        if (labelErrorS) {
          labelErrorS.remove();
        }
      }
    });
  })();
}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1);
module.exports = __webpack_require__(2);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// theme.js